import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import LogoutIcon from "../icons/LogoutIcon";
import MyAccountIcon from "../icons/MyAccountIcon";
import PropTypes from "prop-types";
import { UserCircleIcon } from "@heroicons/react/24/solid";
import { useAuth } from "../services/wp.auth.service";
import { useCallback } from "react";

import { hasRole } from "../services/wp.user.service";
import profileImage from "../assets/profile-image.png";

const imageStyle = {
	height: "auto",
	marginLeft: "1rem",
	width: "50px"
};

const AccountDropdown = ({ userType, headerMenu }) => {

	const {
		logout,
		user
	} = useAuth();
	const navigate = useNavigate();

	const handleLogout = useCallback(() => {
		logout().then(() => {
			navigate("/");
		});
	});

	const itemStyles = {
		whiteSpace: "normal"
	};

	const iconSpanStyles = {
		display: "inline-block",
		textAlign: "center",
		width: "34px"
	};

	return (
		<Dropdown id="my-account-menu">
			<Dropdown.Toggle className="text-dark bg-white border-0 ms-0 ms-sm-3" id="dropdown-basic" variant="secondary">
				<span>
					My Account
				</span>
				{hasRole("respondent")
					? <UserCircleIcon className="i" style={imageStyle} />
					: hasRole("practitioner") &&
						<img alt="profile" className="rounded-circle ms-3" src={user.photo || profileImage} style={imageStyle} />}
			</Dropdown.Toggle>

			<Dropdown.Menu style={{ width: "220px" }}>
				<Dropdown.Item as={Link} className="d-flex align-items-center px-2" styles={itemStyles} to={`/${userType}/my-account`}>
					<span style={iconSpanStyles}>
						<MyAccountIcon size="25px" />
					</span>

					<span>
						My Account
					</span>
				</Dropdown.Item>

				<Dropdown.Divider />

				{
					headerMenu instanceof Array
						? headerMenu?.map((item) => (
							<Dropdown.Item
								as={Link}
								className="d-flex align-items-center px-2"
								key={item.slug}
								styles={itemStyles}
								to={item.route}
							>
								<span style={iconSpanStyles}>
									{item.icon}
								</span>

								<span>
									{item.name}
								</span>
							</Dropdown.Item>
						))
						: ""
				}

				<Dropdown.Item className="d-flex align-items-center px-2" onClick={handleLogout} styles={itemStyles}>
					<span style={iconSpanStyles}>
						<LogoutIcon />
					</span>

					<span>
						Log Out
					</span>
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

};

AccountDropdown.propTypes = {
	headerMenu: PropTypes.arrayOf(PropTypes.object),
	userType: PropTypes.string.isRequired
};

AccountDropdown.defaultProps = {
	headerMenu: null
};

export default AccountDropdown;
